import React from 'react';
import _02 from '../../img/flags/02.png';
import _03 from '../../img/flags/03.png';
import _06 from '../../img/flags/06.png';
import _07 from '../../img/flags/07.png';
import _08 from '../../img/flags/08.png';
import _0A from '../../img/flags/0A.png';
import _0B from '../../img/flags/0B.png';
import _0C from '../../img/flags/0C.png';
import _0D from '../../img/flags/0D.png';
import _0E from '../../img/flags/0E.png';
import _0F from '../../img/flags/0F.png';
import _0G from '../../img/flags/0G.png';
import _0H from '../../img/flags/0H.png';
import _0I from '../../img/flags/0I.png';
import _0K from '../../img/flags/0K.png';
import _0L from '../../img/flags/0L.png';
import _0M from '../../img/flags/0M.png';
import _0N from '../../img/flags/0N.png';
import _0O from '../../img/flags/0O.png';
import _0S from '../../img/flags/0S.png';
import _0V from '../../img/flags/0V.png';
import _11 from '../../img/flags/11.png';
import _13 from '../../img/flags/13.png';
import _16 from '../../img/flags/16.png';
import _17 from '../../img/flags/17.png';
import _18 from '../../img/flags/18.png';
import _19 from '../../img/flags/19.png';
import _1A from '../../img/flags/1A.png';
import _1B from '../../img/flags/1B.png';
import _1E from '../../img/flags/1E.png';
import _1F from '../../img/flags/1F.png';
import _1H from '../../img/flags/1H.png';
import _1I from '../../img/flags/1I.png';
import _1K from '../../img/flags/1K.png';
import _1L from '../../img/flags/1L.png';
import _1P from '../../img/flags/1P.png';
import _1Q from '../../img/flags/1Q.png';
import _1U from '../../img/flags/1U.png';
import _21 from '../../img/flags/21.png';
import _22 from '../../img/flags/22.png';
import _25 from '../../img/flags/25.png';
import _29 from '../../img/flags/29.png';
import _2A from '../../img/flags/2A.png';
import _2F from '../../img/flags/2F.png';
import _2G from '../../img/flags/2G.png';
import _2H from '../../img/flags/2H.png';
import _2I from '../../img/flags/2I.png';
import _2J from '../../img/flags/2J.png';
import _2K from '../../img/flags/2K.png';
import _2L from '../../img/flags/2L.png';
import _2M from '../../img/flags/2M.png';
import _2N from '../../img/flags/2N.png';
import _2O from '../../img/flags/2O.png';
import _2P from '../../img/flags/2P.png';
import _2R from '../../img/flags/2R.png';
import _2S from '../../img/flags/2S.png';
import _2T from '../../img/flags/2T.png';
import _2U from '../../img/flags/2U.png';
import _30 from '../../img/flags/30.png';
import _31 from '../../img/flags/31.png';
import _32 from '../../img/flags/32.png';
import _34 from '../../img/flags/34.png';
import _38 from '../../img/flags/38.png';
import _3A from '../../img/flags/3A.png';
import _3B from '../../img/flags/3B.png';
import _3C from '../../img/flags/3C.png';
import _3D from '../../img/flags/3D.png';
import _3E from '../../img/flags/3E.png';
import _3G from '../../img/flags/3G.png';
import _3I from '../../img/flags/3I.png';
import _3K from '../../img/flags/3K.png';
import _3L from '../../img/flags/3L.png';
import _3M from '../../img/flags/3M.png';
import _3N from '../../img/flags/3N.png';
import _3O from '../../img/flags/3O.png';
import _3P from '../../img/flags/3P.png';
import _3Q from '../../img/flags/3Q.png';
import _3R from '../../img/flags/3R.png';
import _3S from '../../img/flags/3S.png';
import _3U from '../../img/flags/3U.png';
import _3V from '../../img/flags/3V.png';
import _43 from '../../img/flags/43.png';
import _44 from '../../img/flags/44.png';
import _46 from '../../img/flags/46.png';
import _47 from '../../img/flags/47.png';
import _4A from '../../img/flags/4A.png';
import _4B from '../../img/flags/4B.png';
import _4C from '../../img/flags/4C.png';
import _4F from '../../img/flags/4F.png';
import _4J from '../../img/flags/4J.png';
import _4K from '../../img/flags/4K.png';
import _4N from '../../img/flags/4N.png';
import _4O from '../../img/flags/4O.png';
import _4P from '../../img/flags/4P.png';
import _4R from '../../img/flags/4R.png';
import _4T from '../../img/flags/4T.png';
import _50 from '../../img/flags/50.png';
import _52 from '../../img/flags/52.png';
import _55 from '../../img/flags/55.png';
import _57 from '../../img/flags/57.png';
import _59 from '../../img/flags/59.png';
import _5A from '../../img/flags/5A.png';
import _5B from '../../img/flags/5B.png';
import _5C from '../../img/flags/5C.png';
import _5E from '../../img/flags/5E.png';
import _5F from '../../img/flags/5F.png';
import _5H from '../../img/flags/5H.png';
import _5K from '../../img/flags/5K.png';
import _5M from '../../img/flags/5M.png';
import _5P from '../../img/flags/5P.png';
import _5Q from '../../img/flags/5Q.png';
import _5R from '../../img/flags/5R.png';
import _5S from '../../img/flags/5S.png';
import _5U from '../../img/flags/5U.png';
import _61 from '../../img/flags/61.png';
import _62 from '../../img/flags/62.png';
import _63 from '../../img/flags/63.png';
import _64 from '../../img/flags/64.png';
import _65 from '../../img/flags/65.png';
import _67 from '../../img/flags/67.png';
import _68 from '../../img/flags/68.png';
import _6A from '../../img/flags/6A.png';
import _6B from '../../img/flags/6B.png';
import _6C from '../../img/flags/6C.png';
import _6D from '../../img/flags/6D.png';
import _6F from '../../img/flags/6F.png';
import _6G from '../../img/flags/6G.png';
import _6H from '../../img/flags/6H.png';
import _6J from '../../img/flags/6J.png';
import _6P from '../../img/flags/6P.png';
import _6R from '../../img/flags/6R.png';
import _6T from '../../img/flags/6T.png';
import _6V from '../../img/flags/6V.png';
import _70 from '../../img/flags/70.png';
import _71 from '../../img/flags/71.png';
import _72 from '../../img/flags/72.png';
import _73 from '../../img/flags/73.png';
import _76 from '../../img/flags/76.png';
import _77 from '../../img/flags/77.png';
import _78 from '../../img/flags/78.png';
import _79 from '../../img/flags/79.png';
import _7C from '../../img/flags/7C.png';
import _7D from '../../img/flags/7D.png';
import _7G from '../../img/flags/7G.png';
import _7I from '../../img/flags/7I.png';
import './pngFlag.css';

const _map = {
    "02": _02,
    "03": _03,
    "06": _06,
    "07": _07,
    "08": _08,
    "0A": _0A,
    "0B": _0B,
    "0C": _0C,
    "0D": _0D,
    "0E": _0E,
    "0F": _0F,
    "0G": _0G,
    "0H": _0H,
    "0I": _0I,
    "0K": _0K,
    "0L": _0L,
    "0M": _0M,
    "0N": _0N,
    "0O": _0O,
    "0S": _0S,
    "0V": _0V,
    "11": _11,
    "13": _13,
    "16": _16,
    "17": _17,
    "18": _18,
    "19": _19,
    "1A": _1A,
    "1B": _1B,
    "1E": _1E,
    "1F": _1F,
    "1H": _1H,
    "1I": _1I,
    "1K": _1K,
    "1L": _1L,
    "1P": _1P,
    "1Q": _1Q,
    "1U": _1U,
    "21": _21,
    "22": _22,
    "25": _25,
    "29": _29,
    "2A": _2A,
    "2F": _2F,
    "2G": _2G,
    "2H": _2H,
    "2I": _2I,
    "2J": _2J,
    "2K": _2K,
    "2L": _2L,
    "2M": _2M,
    "2N": _2N,
    "2O": _2O,
    "2P": _2P,
    "2R": _2R,
    "2S": _2S,
    "2T": _2T,
    "2U": _2U,
    "30": _30,
    "31": _31,
    "32": _32,
    "34": _34,
    "38": _38,
    "3A": _3A,
    "3B": _3B,
    "3C": _3C,
    "3D": _3D,
    "3E": _3E,
    "3G": _3G,
    "3I": _3I,
    "3K": _3K,
    "3L": _3L,
    "3M": _3M,
    "3N": _3N,
    "3O": _3O,
    "3P": _3P,
    "3Q": _3Q,
    "3R": _3R,
    "3S": _3S,
    "3U": _3U,
    "3V": _3V,
    "43": _43,
    "44": _44,
    "46": _46,
    "47": _47,
    "4A": _4A,
    "4B": _4B,
    "4C": _4C,
    "4F": _4F,
    "4J": _4J,
    "4K": _4K,
    "4N": _4N,
    "4O": _4O,
    "4P": _4P,
    "4R": _4R,
    "4T": _4T,
    "50": _50,
    "52": _52,
    "55": _55,
    "57": _57,
    "59": _59,
    "5A": _5A,
    "5B": _5B,
    "5C": _5C,
    "5E": _5E,
    "5F": _5F,
    "5H": _5H,
    "5K": _5K,
    "5M": _5M,
    "5P": _5P,
    "5Q": _5Q,
    "5R": _5R,
    "5S": _5S,
    "5U": _5U,
    "61": _61,
    "62": _62,
    "63": _63,
    "64": _64,
    "65": _65,
    "67": _67,
    "68": _68,
    "6A": _6A,
    "6B": _6B,
    "6C": _6C,
    "6D": _6D,
    "6F": _6F,
    "6G": _6G,
    "6H": _6H,
    "6J": _6J,
    "6P": _6P,
    "6R": _6R,
    "6T": _6T,
    "6V": _6V,
    "70": _70,
    "71": _71,
    "72": _72,
    "73": _73,
    "76": _76,
    "77": _77,
    "78": _78,
    "79": _79,
    "7C": _7C,
    "7D": _7D,
    "7G": _7G,
    "7I": _7I,
};

const _countryMap = {
    "AL": _02,
    "DZ": _03,
    "AD": _06,
    "AO": _07,
    "AI": _08,
    "AG": _0A,
    "AR": _0B,
    "AM": _0C,
    "AW": _0D,
    "AU": _0E,
    "AZ": _0F,
    "BS": _0G,
    "BH": _0H,
    "BD": _0I,
    "BE": _0K,
    "BZ": _0L,
    "BY": _0M,
    "BJ": _0N,
    "BM": _0O,
    "BA": _0S,
    "BR": _0V,
    "VG": _11,
    "BG": _13,
    "MK": _16,
    "CK": _17,
    "TD": _18,
    "CZ": _19,
    "CN": _1A,
    "DK": _1B,
    "DM": _1E,
    "DO": _1F,
    "EG": _1H,
    "EC": _1I,
    "EE": _1K,
    "ET": _1L,
    "PH": _1P,
    "FI": _1Q,
    "FR": _1U,
    "GH": _21,
    "GI": _22,
    "GE": _25,
    "GG": _29,
    "GN": _2A,
    "HK": _2F,
    "CL": _2G,
    "HR": _2H,
    "IN": _2I,
    "ID": _2J,
    "IQ": _2K,
    "IR": _2L,
    "IE": _2M,
    "IS": _2N,
    "IT": _2O,
    "IL": _2P,
    "JP": _2R,
    "YE": _2S,
    "JE": _2T,
    "ZA": _2U,
    "JO": _30,
    "KY": _31,
    "KH": _32,
    "CA": _34,
    "CO": _38,
    "CD": _3A,
    "CG": _3B,
    "KP": _3C,
    "KR": _3D,
    "CR": _3E,
    "CU": _3G,
    "CY": _3I,
    "LS": _3K,
    "LB": _3L,
    "LR": _3M,
    "LY": _3N,
    "LI": _3O,
    "LT": _3P,
    "LV": _3Q,
    "LU": _3R,
    "MO": _3S,
    "HU": _3U,
    "MY": _3V,
    "MT": _43,
    "MA": _44,
    "MU": _46,
    "MR": _47,
    "MD": _4A,
    "MC": _4B,
    "MN": _4C,
    "MM": _4F,
    "WS": _4J,
    "NG": _4K,
    "NU": _4N,
    "AN": _4O,
    "NL": _4P,
    "NO": _4R,
    "NZ": _4T,
    "PK": _50,
    "PA": _52,
    "PE": _55,
    "PL": _57,
    "PT": _59,
    "AF": _5A,
    "AT": _5B,
    "ME": _5C,
    "GW": _5E,
    "KZ": _5F,
    "KG": _5H,
    "GQ": _5K,
    "RS": _5M,
    "UZ": _5P,
    "RO": _5R,
    "RU": _5S,
    "GR": _5U,
    "SM": _61,
    "SA": _62,
    "SN": _63,
    "SC": _64,
    "SG": _65,
    "SK": _67,
    "SI": _68,
    "AE": _6A,
    "GB": _6B,
    "US": _6C,
    "MX": _6D,
    "DE": _6F,
    "LK": _6G,
    "QA": _6H,
    "SD": _6J,
    "KN": _6P,
    "SY": _6T,
    "ES": _6V,
    "SE": _70,
    "CH": _71,
    "TH": _72,
    "TW": _73,
    "TN": _76,
    "TR": _77,
    "TM": _78,
    "UA": _7C,
    "UY": _7D,
    "VN": _7G,
    "ZM": _7I,
    "RE": _5Q,
    "VC": _6R,
    "TC": _79
};

const PngFlag = ({ countryCode, title }) => {
    const flagTag = _map[countryCode] || _countryMap[countryCode];
    if (flagTag === null || flagTag === undefined) {
        return null;
    }
    return <img className='country-flag' title={title} src={flagTag}></img>;
}

export { PngFlag, _map };